module.exports = __webpack_public_path__ + "static/media/singsnap-details.c25f2cb9.jpg";